const SEGMENTS = [
  { key: 'dms', label: 'DMs', cls: 'bg-blue-500/80' },
  { key: 'mentions', label: 'Mentions', cls: 'bg-violet-500/80' },
  { key: 'calls', label: 'Calls', cls: 'bg-emerald-500/80' },
  { key: 'mail', label: 'Mail', cls: 'bg-amber-500/80' },
] as const

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function InboundChart({ days }: { days: any[] | null }) {
  if (!days || days.length === 0) return null
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const total = (d: any) => SEGMENTS.reduce((s, seg) => s + (d[seg.key] ?? 0), 0)
  const max = Math.max(1, ...days.map(total))
  const totals = Object.fromEntries(SEGMENTS.map((s) => [s.key, days.reduce((sum, d) => sum + (d[s.key] ?? 0), 0)]))
  return (
    <div className="rounded-xl bg-card ring-1 ring-border/40 p-4">
      <div className="flex items-baseline justify-between">
        <h2 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Inbound · last 14 days</h2>
        <span className="text-[11px] text-muted-foreground tabular-nums">{days.reduce((s, d) => s + total(d), 0)} total</span>
      </div>
      <div className="mt-3 flex items-end gap-1 h-24">
        {days.map((d) => (
          <div
            key={d.date}
            className="flex-1 flex flex-col-reverse gap-px"
            title={`${d.date}: ${SEGMENTS.map((s) => `${d[s.key] ?? 0} ${s.label.toLowerCase()}`).join(', ')}`}
          >
            {SEGMENTS.map((s) => {
              const v = d[s.key] ?? 0
              if (!v) return null
              return <div key={s.key} className={`${s.cls} rounded-[1px]`} style={{ height: `${Math.max(2, (v / max) * 96)}px` }} />
            })}
          </div>
        ))}
      </div>
      <div className="flex flex-wrap items-center gap-3 mt-2 text-[10px] text-muted-foreground">
        {SEGMENTS.map((s) => (
          <span key={s.key} className="flex items-center gap-1.5">
            <span className={`inline-block w-2 h-2 rounded-[2px] ${s.cls}`} />
            {s.label} <span className="tabular-nums">{totals[s.key]}</span>
          </span>
        ))}
      </div>
    </div>
  )
}
